import styled, { css } from 'styled-components';

import { DataGridProps } from './types';
import { unitCalc } from 'utils/cssUtils';

export const StyledDataGrid = styled.table<DataGridProps>`
  width: 100%;
  background-color: ${({ theme }) => theme.color.foreground1};
  border-collapse: collapse;
  border-spacing: 0;
  border: 1px solid ${({ theme }) => theme.color.border1};
  text-align: initial;
  overflow: auto;
  line-height: normal;
  // Reset some styles as they would get overriden by Accordion or Card parent
  font-size: ${({ theme }) => theme.font.size1};
  color: ${({ theme }) => theme.color.text1};

  ${props =>
    props.noTable &&
    css`
      width: auto;
      background-color: transparent;
      border-collapse: auto;
      border-spacing: 0;
      border: none;
      overflow: auto;
      margin-bottom: 0;
    `};

  ${props =>
    props.noCol &&
    css`
      border-left: none;
      border-right: none;
    `};

  ${props =>
    props.noRow &&
    css`
      border-top: none;
      border-bottom: none;
    `};
`;

export const StyledDataGridBody = styled.tbody<DataGridProps>`
  overflow: auto;
  width: 100%;

  ${props =>
    props.noTable &&
    css`
      border: none;
      background-color: transparent;
      overflow: auto;
      width: 100%;
      line-height: normal;
    `};

  ${props =>
    props.noCol &&
    css`
      border-left: none;
      border-right: none;
    `};

  ${props =>
    props.noRow &&
    css`
      border-top: none;
      border-bottom: none;
    `};
`;

export const StyledDataGridCell = styled.td<
  DataGridProps | HTMLTableCellElement
>`
  font-weight: 300;
  border-left: 1px solid ${({ theme }) => theme.color.border1};
  border-right: 1px solid ${({ theme }) => theme.color.border1};
  padding: ${({ theme }) => unitCalc(theme.baseline, 3, '/')};

  ${props =>
    props.noTable &&
    css`
      background-color: transparent;
      border: none;
    `};

  ${props =>
    props.noCol &&
    css`
      border-left: none;
      border-right: none;
    `};

  ${props =>
    props.noRow &&
    css`
      border-top: none;
      border-bottom: none;
    `};
`;

export const StyledDataGridHeader = styled.thead<DataGridProps>`
  background-color: ${({ theme }) => theme.color.foreground3};
  border-bottom: 1px solid ${({ theme }) => theme.color.border1};
  font-weight: 400;
  font-style: normal;
  line-height: normal;

  ${props =>
    props.noTable &&
    css`
      border: none;
      background-color: transparent;
      overflow: auto;
      width: 100%;
    `};

  ${props =>
    props.noCol &&
    css`
      border-left: none;
      border-right: none;
    `};

  ${props =>
    props.noRow &&
    css`
      border-top: none;
      border-bottom: none;
    `};
`;

export const StyledDataGridHeaderCell = styled.th<DataGridProps>`
  font-weight: 300;
  border-left: 1px solid ${({ theme }) => theme.color.border1};
  border-right: 1px solid ${({ theme }) => theme.color.border1};
  padding: ${({ theme }) => unitCalc(theme.baseline, 3, '/')};
  text-align: left;

  html[dir='rtl'] & {
    text-align: right;
  }

  ${props =>
    props.noTable &&
    css`
      background-color: transparent;
      border: none;
    `};

  ${props =>
    props.noCol &&
    css`
      border-left: none;
      border-right: none;
    `};

  ${props =>
    props.noRow &&
    css`
      border-top: none;
      border-bottom: none;
    `};
`;

export const StyledDataGridHeaderRow = styled.tr``;

export const StyledDataGridRow = styled.tr<DataGridProps>`
  border-bottom: 1px solid ${({ theme }) => theme.color.border1};

  ${props =>
    props.noTable &&
    css`
      border: none;
    `};

  ${props =>
    props.noCol &&
    css`
      border-left: none;
      border-right: none;
    `};

  ${props =>
    props.noRow &&
    css`
      border-top: none;
      border-bottom: none;
    `};
`;
